import PropTypes from 'prop-types';
import React from 'react';
import Moment from 'moment';
import AutoScopeStylesDecorator from '../../../../Common/Utilities/Decorators/AutoScopeStylesDecorator';
import DataTableView from '../../../../Common/Components/DataTableView/DataTableView.jsx';
import applyDecoratorsDoNotUseInNewCode from '../../../../Common/Utilities/Decorators/ApplyDecorators';

class RatesAuditTableView extends React.PureComponent {
    state = {
        currentSort: [{desc: true, id: 'dateTime'}]
    }

    render() {
        const columns = [
            { Header: 'Date / time of action', accessor: v => v.actionCompletedAt, id: 'dateTime', width: 150, Cell: row => <div>{Moment(row.value).format('DD MMM YYYY HH:mm:ss')}</div> },
            { Header: 'User', accessor: v => v.performedByUser.fullName, id: 'userName', width: 200 },
            { Header: 'Action', accessor: v => v.rateCardAction, id: 'action', width: 100 },
            { Header: 'Rates file', accessor: 'rateCardActionAuditId', id: 'downloadLink', width: 200, Cell: row =>
                (
                    <button className="ui button" onClick={ () => this.downloadRequested(row.original) }><i className="download icon" /> Download rate file</button>
                )
            },
        ];
        return (
            <section id="RatesAuditTableView">
                <div className="segment">
                    <DataTableView
                        data={ this.props.auditRecords }
                        columns={ columns }
                        minRows={ 1 }
                        sorted={ this.state.currentSort }
                        onSortedChange={ this.onSortChange }
                    >
                    </DataTableView>
                </div>
            </section>
        );
    }

    onSortChange = (newSort) => {
        this.setState({ currentSort: newSort });
    }

    downloadRequested = (details) => {
        function generateFileName(ownerName, actionCompletedAt, userName, action) {
            return `${Moment(actionCompletedAt).format('YYYY-MM-DD HH-mm-ss')} rate ${action.toLocaleLowerCase()} for ${ownerName} by ${userName}.${action === "UpdateViaApi" ? 'xml' : 'csv'}`
        }

        this.props.downloadRequested(
            details.rateCardActionAuditId,
            details.rateCardAction,
            generateFileName(details.ratesOwner.name, details.actionCompletedAt, details.performedByUser.fullName, details.rateCardAction)
        );
    }

    static propTypes = {
        currentFilter: PropTypes.object,
        auditRecords: PropTypes.object.isRequired,
        downloadRequested: PropTypes.func.isRequired    // downloadRequested(rateCardActionAuditId: int, fileName: string)
    }
}

const withDecorators = applyDecoratorsDoNotUseInNewCode(AutoScopeStylesDecorator);

export default  withDecorators(RatesAuditTableView);
